<div class="statistic-box">
    <div class="statistic-box-title">
        <div class="title">{{data.title}}</div>
        <div class="sub-title">{{data.subTitle}}</div>
    </div>
    <div class="statistic-box-value">
        <div class="status">
            <div class="good" *ngIf="data.good >= 0"><i class="fa fa-check-circle available"></i> Good {{data.good}}</div>
            <div class="bad" *ngIf="data.bad >= 0"><i class="fa fa-info-circle available"></i> Bad {{data.bad}}</div>
        </div>
        <div class="value">{{data.value || 0 | number:'1.0':'en-US'}}</div>
    </div>
</div>
